import { Link } from "react-router-dom";

const ACTIVE = "#276AA6";
const INACTIVE = "#94A3B8";

export default function MobileNavTab({ to, label, icon: Icon, isActive }) {
	return (
		<Link
			to={to}
			className="relative flex flex-1 min-w-0 flex-col items-center justify-center gap-1 py-2 px-1 active:scale-[0.97] transition-transform"
			aria-current={isActive ? "page" : undefined}
		>
			<span
				className={[
					"flex h-10 w-10 items-center justify-center rounded-2xl transition-all duration-200",
					isActive
						? "bg-lightCta shadow-[0_2px_12px_rgba(39,106,166,0.15)] ring-1 ring-darkBlue/15"
						: "bg-transparent",
				].join(" ")}
			>
				<Icon fill={isActive ? ACTIVE : INACTIVE} />
			</span>
			<span
				className={[
					"font-Vazir-600 text-[11px] leading-tight text-center truncate max-w-full transition-colors",
					isActive ? "text-darkBlue font-Vazir-700" : "text-[#94A3B8]",
				].join(" ")}
			>
				{label}
			</span>
			{isActive && (
				<span
					className="absolute bottom-1 left-1/2 h-[3px] w-5 -translate-x-1/2 rounded-full bg-cta"
					aria-hidden
				/>
			)}
		</Link>
	);
}
